import type { Decision } from './schemas';

// Decisões estratégicas do produto. Lista mantida à mão — adicionar nova decisão
// abre PR explícito (justifica decisão + valida com o time).
export const DECISIONS: Decision[] = [
  {
    id: 'd-2026-04-01',
    date: 'Abr/2026',
    title: 'Migração v7 → v8 (React + TanStack)',
    description:
      'Hub passa de monolito ui/index.html (15k linhas) para React + TanStack em web/. ' +
      'Coexistência via /v2/* sem parar o produto. Ganho permanente em manutenibilidade, ' +
      'tipagem e produtividade do Claude Code no codebase.',
  },
  {
    id: 'd-2026-04-02',
    date: 'Abr/2026',
    title: 'Módulos Auditoria, Sessões, Canais e Extrações removidos',
    description:
      'Simplificação do Hub: módulos sem uso ativo foram excluídos definitivamente para ' +
      'reduzir complexidade e foco no core do produto.',
  },
  {
    id: 'd-2026-04-03',
    date: 'Abr/2026',
    title: 'Diagnóstico CMN 5.268/2025 — 21 verificações CNFP/ONR/CAR',
    description:
      'Integração ONR com retry automático em token expirado (erros 498/499). CNFP como ' +
      'fonte principal de conformidade fundiária.',
  },
  {
    id: 'd-2026-04-04',
    date: 'Abr/2026',
    title: 'Hub Ruralplan V2 em produção',
    description:
      'SPA ~13k linhas, 9 containers (wenin-hub/postgres/redis/qdrant), deploy via ' +
      'scp + docker cp. Módulos: Clientes, Fundiário, Crédito, Diagnóstico.',
  },
  {
    id: 'd-2026-03-01',
    date: 'Mar/2026',
    title: 'Smart Intake: OCR Tesseract + Claude Haiku Vision',
    description:
      'Tesseract a 400 DPI para CNH/RG (GPT/Claude recusam documentos de identidade). ' +
      'Claude Haiku Vision para demais documentos. Deduplicação multi-critério.',
  },
  {
    id: 'd-2026-03-02',
    date: 'Mar/2026',
    title: 'PostGIS + pgvector halfvec(1536) HNSW + Qdrant 4 coleções',
    description:
      'Dockerfile.postgres customizado. halfvec(1536) com índice HNSW em produção. ' +
      'Rollback obrigatório nos excepts. Busca semântica BM25 + densa com RRF.',
  },
  {
    id: 'd-2026-03-03',
    date: 'Mar/2026',
    title: 'GEO Fundiário: 14 endpoints, conclusão e propagação',
    description:
      'Kanban de processos com visão 360°, propagação de status, eventos de conclusão. ' +
      'Módulo Fundiário com pipes GEO, CCIR e Titulação.',
  },
  {
    id: 'd-2026-02-01',
    date: 'Fev/2026',
    title: 'Self-hosted VPS — sem dependência de SaaS externo',
    description:
      'Infraestrutura própria em 72.61.131.11 (~R$3/mês). Sem lock-in de plataforma. ' +
      'Dados do produtor rural sempre sob controle da Ruralplan.',
  },
];
